export default __webpack_public_path__ + "static/media/EnergieVerde.8a3421ec.svg";